import { DeepPartial } from '@apollo/client/utilities'
import { ExpensesExpensableApprovableMetadataFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

export const getExpensesExpensableMetadata = (
  data: DeepPartial<ExpensesExpensableApprovableMetadataFragment>
) => {
  const expensableResource = data.expense ?? data.mileage ?? data.perDiem

  if (!expensableResource) {
    return []
  }

  const locale = expensableResource.employee?.access?.locale ?? 'en'

  const displayCategory = expensableResource.category?.name

  const displayAmount = data.amount
    ? MoneyWithCurrency({
        amount: Number(data.amount),
        currency: data.currency,
        locale,
      })
    : undefined

  const displayReimbursableAmount = data.reimbursableAmount
    ? MoneyWithCurrency({
        amount: Number(data.reimbursableAmount),
        currency: data.reimbursableCurrency,
        locale,
      })
    : undefined

  const reimbursableLabel = i18n.t('expenses_v2.list.filters.reimbursable')

  const reimbursableTotally = data.reimbursableAmount === data.amount

  let displayReimbursable: string | undefined
  if (data.reimbursableAmount) {
    displayReimbursable = reimbursableTotally
      ? reimbursableLabel
      : `${reimbursableLabel} (${displayReimbursableAmount})`
  }

  return [displayAmount, displayCategory, displayReimbursable].filter(Boolean)
}
